import { useEffect, useState } from 'react';

/**
 * Shared ~30s clock tick (#563) — returns `Date.now()` and re-renders on a fixed
 * interval so relative timestamps ("3 min ago") and the freshness age advance on
 * their own, without a data refetch. One shared cadence keeps every card and the
 * live/stale stamp in step (and honors prefers-reduced-motion elsewhere; this is
 * a value tick, not an animation).
 */
export function useNowTick(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
